import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-modal-cancel',
  templateUrl: './modal-cancel.component.html',
  styleUrls: ['./modal-cancel.component.scss']
})
export class ModalCancelComponent implements OnInit {

  modalData: any;
  cancelForm: FormGroup;
  type

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ModalCancelComponent>,
    private fb: FormBuilder,
  ) {
    this.modalData = data;
  }

  ngOnInit(): void {
    // console.log(this.modalData);
    this.setType(this.modalData.type);

    this.cancelForm = this.fb.group({
      note: ['', Validators.required],
    })
  }

  setType(type) {
    switch (type) {
      case 'quotation': { this.type = 'ใบเสนอราคา'; break;}
      case 'invoice': { this.type = 'ใบแจ้งหนี้'; break;}
      case 'receipt': { this.type = 'ใบเสร็จ'; break;}
    }
  }

  confirm(form) {
    const response = {
      status: true,
      value: form.note
    }
    this.dialogRef.close(response);
  }

  closeModal() {
    const response = {
      status: false
    }
    this.dialogRef.close(response);
  }

}
